import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const TableFilterAppointmentType = ({
  onChange,
}) => {
  const appointmentTypeOptions = [{
    label: 'Physical Therapy Appointments',
    value: 'Physical',
  }, {
    label: 'Occupational Therapy Appointments',
    value: 'Occupation',
  }, {
    label: 'Speech Therapy Appointments',
    value: 'Speech',
  }];

  const [value, setValue] = useState([]);

  const setFilterValue = (e) => {
    setValue(e);
    if (e) {
      onChange(e.map(ee => ee.value));
    } else {
      onChange(undefined);
    }
  };
  return (
    <Select
      value={value}
      onChange={setFilterValue}
      options={appointmentTypeOptions}
      closeMenuOnSelect={false}
      menuPortalTarget={document.body}
      isMulti
      className="w-100 form-select pt-0 pb-2 px-0"
      classNamePrefix="react-select"
    />
  );
};

TableFilterAppointmentType.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TableFilterAppointmentType;
